import { MenuItem } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";
import { Box, InlineSpinnerIcon } from "ui-components";
import { useDebouncedValue } from "ui-lib";
import React, { useState, useMemo, useEffect } from "react";
import { useQuery, UseQueryResult } from "react-query";
import { useNavigate } from "react-router-dom";
import companySearchQuery, {
  CompanySearch,
} from "ui-io/queries/company-search-query";
import { formatLocation } from "../routes";
import { getCompanyConfig } from "ui-io/queries/get-company-config";
import { FormDataT } from "../utils/constants";

const SelectConfig = Suggest.ofType<CompanySearch>();

const SearchConfig = (props: {
  placeholder?: string;
	mergeWithAnotherData?:(e:UseQueryResult<FormDataT>) => void
}) => {
  const history = useNavigate();
  const [searchKey, setSearchKey] = useState("");
  const [selectedCompanyID, setSelectedCompanyID] = useState<string>("");
  const debouncedSearch = useDebouncedValue(searchKey);

  const getSeparatedSearchKey = (key: string) => {
    const valToSeprate = key.split(" ")[0];
    return valToSeprate.split("").join("_");
  };
  const queryObj = useMemo(() => {
    if (Number.isNaN(Number(debouncedSearch))) {
      return {
        searchKey: debouncedSearch.toLowerCase(),
        separatedSearchKey: getSeparatedSearchKey(debouncedSearch),
      };
    } else {
      return { searchKey: debouncedSearch };
    }
  }, [debouncedSearch]);

  const connection = useQuery({
    ...companySearchQuery({ ...queryObj }),
    enabled: !!queryObj.searchKey.length,
  });

  const configNameList = connection.isSuccess && connection.data;
  const addCompanyIdAtUrl = (value: any) => {
    history(
      formatLocation.configurationCreate({
        companyID: value.companyID,
      })
    );
  };

  const otherCompanyConfig = useQuery({
    ...getCompanyConfig({ companyID: selectedCompanyID }),
    enabled: !!selectedCompanyID,
  });
  useEffect(() => {
		if(props.mergeWithAnotherData && otherCompanyConfig.data)
		props.mergeWithAnotherData(otherCompanyConfig.data) 
  }, [otherCompanyConfig.isSuccess, selectedCompanyID]);
  return (
    <Box mr={1}>
      <SelectConfig
        inputProps={{
          round: true,
          placeholder: props?.placeholder ? props.placeholder : "Search",
          // value: searchKey,
        }}
        closeOnSelect
        onQueryChange={setSearchKey}
        items={configNameList ? configNameList : []}
        noResults={
          connection.isLoading ? (
            <InlineSpinnerIcon />
          ) : (
            <MenuItem disabled={true} text="No results" />
          )
        }
        onItemSelect={
          props?.placeholder
            ? (value: any) => setSelectedCompanyID(value.companyID)
            : addCompanyIdAtUrl
        }
        itemRenderer={(item, itemProps) => (
          <MenuItem
            key={item.companyID}
            active={itemProps.modifiers.active}
            text={item.name}
            onClick={itemProps.handleClick}
          />
        )}
        inputValueRenderer={(value) => value.name}
        popoverProps={{ minimal: true }}
      />
    </Box>
  );
};
export default SearchConfig;
